<template>
  <modal
    :name="name"
    :click-to-close="clickToClose"
    :resizable="resizable"
    :adaptive="true"
    :scrollable="true"
    :width="width"
    :height="height"
    classes="modal-base-vjsm modal-override"
    :class="{
      'modal-base-vjsm--padded': padded,
      'modal-base-vjsm--opacity': opacity,
      'modal-base-vjsm--fullscreen-mobile': mobileFullScreen,
      'modal-base-vjsm--fullscreen-desktop': desktopFullScreen,
    }"
    @opened="emitStatus(true)"
    @closed="emitStatus(false)"
  >
    <div class="modal-base-vjsm__container">
      <div
        v-if="closeButton"
        class="modal-base-vjsm__close"
      >
        <button
          class="button"
          @click.prevent="closeModal()"
        >
          <div class="button__icon">
            <icon
              icon="Close"
            />
          </div>
        </button>
      </div>

      <div
        v-if="hasTitle"
        class="modal-base-vjsm__title"
      >
        <h1 class="title">
          <slot name="title" />
        </h1>
      </div>

      <div class="modal-base-vjsm__content">
        <slot />
      </div>
    </div>
  </modal>
</template>

<script>
  export default {
    name: 'ModalElement',

    props: {
      // Name, used as ID
      name: {
        type: String,
        required: true,
      },
      // Trigger show and hide method
      show: {
        type: Boolean,
        default: false,
      },
      padded: {
        type: Boolean,
        default: true,
      },
      opacity: {
        type: Boolean,
        default: false,
      },
      resizable: {
        type: Boolean,
        default: false,
      },
      width: {
        type: String,
        default: '300',
      },
      height: {
        type: String,
        default: 'auto',
      },
      mobileFullScreen: {
        type: Boolean,
        default: false,
      },
      desktopFullScreen: {
        type: Boolean,
        default: false,
      },
      clickToClose: {
        type: Boolean,
        default: false,
      },
      closeButton: {
        type: Boolean,
        default: false,
      },
    },

    computed: {
      hasTitle() {
        return !!this.$slots.title;
      },
    },

    watch: {
      show(status) {
        if (status) {
          this.openModal();
        } else {
          this.closeModal();
        }
      },
    },

    mounted() {
      if (this.show) {
        this.openModal();
      }
    },

    methods: {
      closeModal() {
        this.$modal.hide(this.name);
      },

      openModal() {
        this.$modal.show(this.name);
      },

      emitStatus(status) {
        this.$emit('modalVisible', status);
      },
    },
  };
</script>

<style lang="scss">
  .modal-base-vjsm {
    border-radius: 0.5rem !important;
    background-color: white !important;
    box-shadow: 0 20px 60px -2px rgba(27, 33, 58, 0.4);

    &__container {
      padding: 0;
      position: relative;
    }

    &__close {
      position: absolute;
      top: 0.6rem;
      right: 0.6rem;

      .button {
        padding: 0.6rem;
        transition: 0.2s all ease-out;
        outline: 0;
        border-radius: $radius-full;

        &__icon {
          color: #d8d8d8;
          height: 1rem;
          width: 1rem;
        }

        &:hover {
          transition: 0.2s all ease-in;
          transform: scale(1.1);
        }
      }
    }

    &__icon {
      padding: 0 0 0.8rem 0;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    &__title {
      padding: 0 0 1rem 0;
      width: 100%;
      text-align: center;

      .title {
        margin-bottom: 0;
        font-size: 1.4rem;
        font-weight: 700;
      }
    }

    &__content {
      text-align: justify;
      font-size: 1.1rem;
      font-weight: 400;
    }

    &--fullscreen {
      &-mobile {
        @include screen(phone-only) {
          .modal-base-vjsm__container {
            min-height: 100vh !important;
            width: 100vw !important;
          }

          .v--modal {
            border-radius: 0.5rem !important;
            width: 100% !important;
            left: 0 !important;
          }
        }
      }

      &-desktop {
        @include screen(phone-big-up) {
          .modal-base-vjsm__container {
            min-height: 100vh !important;
            width: 100vw !important;
          }

          .v--modal {
            border-radius: 0.5rem !important;
            width: 100% !important;
            left: 0 !important;
          }
        }
      }
    }

    &--padded {
      .modal-base-vjsm__container {
        padding: 0.8rem 1rem;
      }
    }

    &--opacity {
      opacity: 0.99;
    }
  }
</style>
